import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VISITOR_KEY = "kg_visitor_id";
const TOKEN_KEY = "kg_auth_token";

function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `v_${Date.now()}_${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function track(type, extra = {}) {
  // Skip admin routes — owner activity should not pollute their own analytics.
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) return;
  const payload = { type, visitor_id: getVisitorId(), ...extra };
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  axios.post(`${API}/analytics/track`, payload, { headers }).catch(() => {});
}
